export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/occurrence-training-progress`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        getProgresses: {
            method: 'POST',
            url: `${url}/progresses`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/TrainingProgress/index.js